import $ from "jquery";

let displayLoginModal = function () {
    let loginModal = $("div#loginModal");
    loginModal.modal('show');
};

export default displayLoginModal;